export default __webpack_public_path__ + "static/care02-db803dc2d5c9b1c8e8bf25a6032d02b6.png";